import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HrmsImage from '../../assets/Hrms.png';
import { axiosInstance, localAxios } from '../../Axios/axios';
import axios from 'axios';
import Loader from '../../components/Loader';


import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    firstName: '',
    lastName: '',
    organizationName: '',
    contactNumber: '',
    email: '',
    doj: null, 
  });

  const handleChange = (field) => (event) => {
    
    setInputValues({ ...inputValues, [field]: event.target.value });
  };

 
  const handleDateChange = (newValue) => {
    setInputValues({ ...inputValues, doj: newValue });
  };

  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'error'
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false })
  };

  const handleRegister = async () => {
    setIsLoading(true);
    setSnackbar({ open: false, message: '', severity: 'error' })

    const requestData = {
      first_name: inputValues.firstName,
      last_name: inputValues.lastName,
      email: inputValues.email,
      organization_name: inputValues.organizationName,
      department: null,
      team: null,
      designation: null,
     
      doj: inputValues.doj ? inputValues.doj.toISOString().split('T')[0] : null,
      status: "active",
      user_type: "Hr",
      phone_number: inputValues.contactNumber
    };

    console.log("Sending registration data:", requestData);

    try {
      const response = await axiosInstance(localAxios('/organization/hrSignup', requestData));

      console.log("Registration Response:", response.data);
      console.log("User Details:", response.data.message.user);
      console.log("User ID:", response.data.message.user.id);
      console.log("Organization ID:", response.data.message.user.organization_id);

      localStorage.setItem('userDetails', JSON.stringify(response.data.message.user));

      if (response.data.message.user) {
        localStorage.setItem('userId', response.data.message.user.id);
        localStorage.setItem('organizationId', response.data.message.user.organization_id);

        if (response.data.message.accessToken) {
          localStorage.setItem('accessToken', response.data.message.accessToken);
          console.log("Access Token stored");
        }
        if (response.data.message.refreshToken) {
          localStorage.setItem('refreshToken', response.data.message.refreshToken);
          console.log("Refresh Token stored");
        }

        console.log("Stored in localStorage - userId:", localStorage.getItem('userId'));
        console.log("Stored in localStorage - organizationId:", localStorage.getItem('organizationId'));

        setRegistrationSuccess(true);
        setIsButtonDisabled(true);
        setOpenSuccessPopup(true);

      } else {
        const errorMessage = response.data.message?.error || response.data.message || 'An unexpected error occurred during registration.'
        setSnackbar({ open: true, message: errorMessage, severity: 'error' })
      }

    }
    catch (error) {
      console.error("Registration Error:", error.response ? error.response.data : error.message);

      let errorMessageText = 'Failed to Register. Please try again';
      if (error.response?.data?.message) {
        errorMessageText = error.response.data.message;
      }
      setSnackbar({
        open: true,
        message: errorMessageText,
        severity: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClosePopup = () => {
    setOpenSuccessPopup(false);
    navigate('/login');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        height: '100vh',
        width: '100vw',
        backgroundColor: 'rgba(41, 41, 41, 1)',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${HrmsImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      ></Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: { xs: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            width: { xs: '90%', md: '60%' },
            maxWidth: '350px',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
              mb: 2,
              color: '#ffffff',
              textAlign: 'center',
            }}
          >
            Welcome to HRMS
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mb: 3,
              color: '#bbbbbb',
              textAlign: 'center',
            }}
          >
            Create an account to get started with HRMS and start managing your
            business.
          </Typography>

          <form>
            <Grid container spacing={2}>
              {[
                { field: 'firstName', placeholder: 'Enter first name', label: 'First Name' },
                { field: 'lastName', placeholder: 'Enter last name', label: 'Last Name' },
                { field: 'organizationName', placeholder: 'Enter Organization name', label: 'Organization Name' },
                {
                  field: 'contactNumber',
                  placeholder: 'Enter contact number',
                  label: 'Contact Number',
                  type: 'tel',
                  inputProps: { maxLength: 10 },
                  onChange: (e) => {
                    const digitsOnly = e.target.value.replace(/\D/g, '');
                    if (digitsOnly.length <= 10) {
                      setInputValues((prev) => ({ ...prev, contactNumber: digitsOnly }));
                    }
                  },
                },
                { field: 'email', placeholder: 'Enter email address', label: 'Email' },
              ].map(({ field, placeholder, type, label, inputProps, onChange }) => (
                <Grid item xs={12} key={field}>
                  <TextField
                    fullWidth
                    label={label}
                    placeholder={placeholder}
                    variant="outlined"
                    size="small"
                    type={type || 'text'}
                    value={inputValues[field]}
                    onChange={onChange || handleChange(field)}
                    inputProps={inputProps || {}}
                    InputProps={{
                      style: { color: '#000000' },
                    }}
                    InputLabelProps={{
                      style: { color: '#bbbbbb' },
                      sx: {
                        '&.Mui-focused': { color: '#ffffff' },
                        '&.MuiFormLabel-colorPrimary': { color: '#fff' },
                        '&.MuiInputLabel-shrink': { color: '#ffffff' },
                      }
                    }}
                    sx={{
                      backgroundColor: '#ffffff',
                      borderRadius: '4px',
                      '& .MuiInputBase-input::placeholder': {
                        color: '#bbbbbb',
                        opacity: 1,
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#bbbbbb',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ffffff',
                      },
                      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ffffff',
                      },
                      '& .MuiInputLabel-root': {
                        color: '#bbbbbb',
                      },
                    }}
                  />
                </Grid>
              ))}

             
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Date of Joining"
                    value={inputValues.doj}
                    onChange={handleDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        variant: "outlined",
                        InputProps: { style: { color: '#000000' } },
                        InputLabelProps: {
                          style: { color: '#bbbbbb' },
                          sx: {
                            '&.Mui-focused': { color: '#ffffff' },
                            '&.MuiFormLabel-colorPrimary': { color: '#bbbbbb' },
                            '&.MuiInputLabel-shrink': { color: '#ffffff' },
                          }
                        },
                        sx: {
                          backgroundColor: '#ffffff',
                          borderRadius: '4px',
                          '& .MuiInputBase-input::placeholder': {
                            color: '#bbbbbb',
                            opacity: 1,
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#bbbbbb',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ffffff',
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ffffff',
                          },
                          '& .MuiInputLabel-root': {
                            color: '#bbbbbb',
                          },
                          '& .MuiInputAdornment-root .MuiIconButton-root': {
                            color: '#bbbbbb',
                            '&:hover': { color: '#ffffff' },
                          },
                        },
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: '#ffffff',
                        '&.Mui-checked': { color: '#ffffff' },
                      }}
                    />
                  }
                  label={
                    <Typography variant="caption" sx={{ color: '#bbbbbb' }}>
                      I agree to the Terms of Service and Privacy Policy
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: '#1a237e',
                    color: '#fff',
                    padding: '10px',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    '&:hover': {
                      backgroundColor: '#0d47a1',
                    },
                  }}
                  onClick={handleRegister}
                  disabled={isButtonDisabled}
                >
                  Register
                </Button>

                <Grid item xs={12} sx={{ mt: 2, textAlign: 'center' }}>
                  <Typography variant="body2" sx={{ color: '#bbbbbb' }}>
                    Already have an account?{' '}
                    <Box
                      component="span"
                      sx={{
                        color: '#ffffff',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        '&:hover': { color: '#1a237e' },
                      }}
                      onClick={() => navigate('/login')}
                    >
                      Login here
                    </Box>
                  </Typography>
                </Grid>
              </Grid>

              {registrationSuccess && (
                <Grid item xs={12} sx={{ mt: 1, textAlign: 'center' }}>
                  <Typography variant="body2" sx={{ color: '#bbbbbb' }}>
                    A Register link has been sent to your email.
                  </Typography>
                </Grid>
              )}
            </Grid>
          </form>

        </Box>
      </Box>

     
      <Dialog
        open={openSuccessPopup}
        onClose={handleClosePopup}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            maxWidth: '400px',
            width: '90%'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#1a237e',
          color: 'white',
          textAlign: 'center',
          fontWeight: 'bold'
        }}>
          Registration Successful!
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2 }}>
          <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
            Your account has been created successfully.
          </Typography>
          <Typography variant="body2" sx={{ textAlign: 'center', color: '#666' }}>
            A verification link has been sent to your email address.
            Please check your inbox and verify your account.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button
            onClick={handleClosePopup}
            variant="contained"
            sx={{
              backgroundColor: '#1a237e',
              color: '#fff',
              padding: '8px 24px',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#0d47a1',
              },
            }}
          >
            Continue to Login
          </Button>
        </DialogActions>
      </Dialog>

     
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isLoading && <Loader />}
    </Box>
  );
};

export default RegisterPage;